<template>
  <div>
    <!-- <CRow> -->
      
        <img class="center"
          src="/static/img/brand/dashboard.png"
        />
    <!-- </CRow> -->
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";
import MainChart from "@/views/base/MainChart";
import { DatePicker } from "v-calendar";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: 'Dashboard',
  components: { BaseSelect, MainChart, BaseFormLoading, DatePicker },
  data() {
    let that = this;
    return {
      loading: { value: false },
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  },
  watch: {

  }
}
</script>

<style scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
